import { cva, cx, type VariantProps } from 'class-variance-authority';

export const menuPanelCva = cx(
  'fixed z-50 flex max-h-80 w-70 flex-col',
  'origin-(--ngp-menu-transform-origin)',
  'scrollbar overflow-y-auto rounded-lg outline-none',
  'border border-neutral-50 bg-white shadow-sm',
);

export const menuItemCva = cva(
  [
    'flex w-full items-center',
    'cursor-pointer text-start font-normal outline-none select-none',
    'data-disabled:pointer-events-none data-disabled:text-neutral-200',
    'disabled:pointer-events-none disabled:text-neutral-200',
  ],
  {
    variants: {
      destructive: {
        false: 'text-neutral-900 hover:bg-neutral-50 focus-visible:bg-neutral-50',
        true: 'text-error-500 hover:bg-error-50 focus-visible:bg-error-50',
      },
      surface: {
        panel: 'min-h-9.5 gap-2.5 px-4 text-body-small',
        sheet: 'min-h-13 gap-3 rounded-lg px-3 text-body',
      },
    },
    defaultVariants: {
      destructive: false,
      surface: 'panel',
    },
  },
);

export const menuLabelCva = cx('flex-auto truncate');

export const menuTrailingCva = cva('ml-auto shrink-0 text-neutral-300', {
  variants: {
    surface: {
      panel: 'text-caption',
      sheet: 'text-body',
    },
  },
  defaultVariants: {
    surface: 'panel',
  },
});

export const menuSeparatorCva = cx('my-1.5 h-px w-full shrink-0 bg-neutral-50');

export const menuGroupTitleCva = cva(
  'flex w-full items-center justify-between gap-1.5 font-semibold uppercase text-neutral-300',
  {
    variants: {
      surface: {
        panel: 'pt-2.5 px-4 pb-0.5  text-caption',
        sheet: 'px-3 pt-3 pb-1 text-label',
      },
    },
    defaultVariants: {
      surface: 'panel',
    },
  },
);

export const menuSheetCva = cx(
  'flex flex-col gap-1 overflow-hidden rounded-t-2xl bg-white px-4 pt-8 pb-10',
);

export type MenuItemVariants = VariantProps<typeof menuItemCva>;
